import script from "./CardExercise.vue?vue&type=script&setup=true&lang=js"
export * from "./CardExercise.vue?vue&type=script&setup=true&lang=js"

import "./CardExercise.vue?vue&type=style&index=0&id=e46df494&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e46df494"]])

export default __exports__